// src/config/gauges/fsc_v2_1comp.js

export const fscV21CompGaugeConfig = [
  {
    key: "tempEvapSalida",
    title: "Temp. Evap. Salida",
    unit: "°C",
    ranges: [
      { min: 7, max: 8.99, color: "green" },
        { min: 5, max: 6.99, color: "yellow" },  
        { min: 9, max: 19.99, color: "yellow" },  
        { min: 0, max: 4.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
    ],
  },
  {
    key: "tempDescarga",
    title: "Temp. Descarga",
    unit: "°C",
    ranges: [
      { min: 60, max: 79.99, color: "green" },
        { min: 50, max: 59.99, color: "yellow" },
        { min: 80, max: 89.99, color: "yellow" },
        { min: 0, max: 49.99, color: "red" },
        { min: 90, max: 50000, color: "red" },
    ],
  },
  {
    key: "presionSuccion",
    title: "Pres. Succión",
    unit: "psi",
    ranges: [
      { min: 33, max: 39.99, color: "green" },
        { min: 29, max: 32.99, color: "yellow" },
        { min: 40, max: 49.99, color: "yellow" },
        { min: 0, max: 28.99, color: "red" },
        { min: 50, max: 20000, color: "red" },
    ],
  },
  {
    key: "presionDescarga",
    title: "Pres. Descarga",
    unit: "psi",
    ranges: [
      { min: 170, max: 189.99, color: "green" },
        { min: 150, max: 169.99, color: "yellow" },
        { min: 190, max: 209.99, color: "yellow" },
        { min: 0, max: 149.99, color: "red" },
        { min: 210, max: 25000, color: "red" },
    ],
  },
  {
    key: "sobrecalentamiento",
    title: "Sobrecalentamiento",
    unit: "°C",
    ranges: [
      { min: 10, max: 19.99, color: "green" },
      { min: 5, max: 9.99, color: "yellow" },
      { min: 20, max: 24.99, color: "yellow" },
      { min: -50, max: 4.99, color: "red" },
      { min: 25,  max: 20000, color: "red" },
    ],
  },
  {
    key: "tempSuccion",
    title: "Temp. Succión",
    unit: "°C",
    ranges: [
      { min: 10, max: 14.99, color: "green" },
      { min: 6, max: 9.99, color: "yellow" },
      { min: 15, max: 19.99, color: "yellow" },
      { min: -50, max: 5.99, color: "red" },
      { min: 20,  max: 20000, color: "red" },
    ],
  },
];